import { keepPreviousData } from '@tanstack/react-query'
import { learningItemParser } from '../../models/LearningItem'
import { useApiQuery } from '../useApiQuery'
import { z } from 'zod'
import * as api from '../api'
import { ReturnsPathLearningItems } from '../useInvalidate'

export default function usePathLearningItems(learningItemUuid: string) {
  const { data, ...result } = useApiQuery({
    queryKey: ['pathLearningItems', ReturnsPathLearningItems, learningItemUuid],
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const res = await api.get(`learning-path/${encodeURIComponent(learningItemUuid)}/learning-items`)

      return z.array(learningItemParser).parse(res)
    },
  })

  return { pathLearningItems: data || [], ...result }
}
